import { FC } from "react";

interface IconProps {
  color?: string;
}

const Burger: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 32 32" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 22.333h10.667M7 15.667h18.667M15 9h10.667"
      fill="none"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Burger;
